export default __webpack_public_path__ + "static/FairlyConfident-102029c9fe97a2cdaf6f419bc071ef25.svg";